module.exports = __webpack_public_path__ + "static/media/no-signal.2ed995b7.svg";